import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const ROLE_REDIRECTS = {
  admin: '/admin',
  comercial: '/comercial',
  tecnico: '/tecnico',
  cliente: '/dashboard',
  user: '/dashboard',
};

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = new URLSearchParams(window.location.hash.substring(1)).get('session_id');
    (async () => {
      try {
        const userData = await loginWithGoogle(sessionId);
        window.history.replaceState(null, '', window.location.pathname);
        navigate(ROLE_REDIRECTS[userData.role] || '/dashboard', { replace: true, state: { user: userData } });
      } catch (err) {
        const detail = err.response?.data?.detail;
        window.history.replaceState(null, '', '/login');
        navigate('/login', {
          replace: true,
          state: { googleError: typeof detail === 'string' ? detail : 'GOOGLE_ERROR' },
        });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#030303' }} data-testid="auth-callback">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-white/20 border-t-white rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-zinc-500 font-['Manrope']">Verificando tu cuenta...</p>
      </div>
    </div>
  );
}
